/* ODCAF Express — make product page info sections foldable (click the heading to open/close).
   The first section on the page starts open; the rest start closed. A section opens automatically
   when a link points to it (#id) or when something inside it is clicked from elsewhere. */
(function () {
  if (window.__odxFold) return;
  window.__odxFold = true;

  var css = '' +
    '.odx-fold .odx-pdp-sec__title{display:flex;align-items:center;justify-content:space-between;gap:16px;cursor:pointer;user-select:none;margin:0 !important;transition:color .15s}' +
    '.odx-fold .odx-pdp-sec__title:hover{color:#d4147f}' +
    '.odx-fold .odx-pdp-sec__title:focus-visible{outline:2px solid #00a8ff;outline-offset:4px;border-radius:6px}' +
    '.odx-fold__ico{flex:none;position:relative;width:34px;height:34px;border-radius:50%;background:#0d0d1a;transition:transform .25s,background .15s}' +
    '.odx-fold__ico:before,.odx-fold__ico:after{content:"";position:absolute;left:50%;top:50%;width:14px;height:2px;margin:-1px 0 0 -7px;background:#fff;border-radius:2px;transition:transform .25s}' +
    '.odx-fold__ico:after{transform:rotate(90deg)}' +
    '.odx-fold.is-open .odx-fold__ico{background:#d4147f}' +
    '.odx-fold.is-open .odx-fold__ico:after{transform:rotate(0deg)}' +
    '.odx-fold__body{display:grid;grid-template-rows:1fr;transition:grid-template-rows .3s ease}' +
    '.odx-fold__inner{min-height:0;overflow:hidden}' +
    '.odx-fold__inner>.odx-pdp-wrap:first-of-type{padding-top:22px}' +
    '.odx-fold:not(.is-open) .odx-fold__body{grid-template-rows:0fr}' +
    '.odx-pdp-sec.odx-fold{padding-top:26px;padding-bottom:26px;border-top:1px solid #e8e8ef}' +
    '.odx-pdp-sec.odx-fold.is-open{padding-bottom:48px}' +
    '.odx-fold__hint{display:block;font-family:var(--font-body-family);font-size:13px;font-weight:500;color:#5b5d6b;margin-top:2px}' +
    '@media (max-width:749px){.odx-pdp-sec.odx-fold{padding-top:18px;padding-bottom:18px}.odx-pdp-sec.odx-fold.is-open{padding-bottom:32px}.odx-fold__ico{width:30px;height:30px}}';

  function addStyle() {
    var st = document.createElement('style');
    st.id = 'odx-fold-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function setOpen(sec, open) {
    sec.classList.toggle('is-open', open);
    var t = sec.querySelector('.odx-pdp-sec__title');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    var body = sec.querySelector('.odx-fold__body');
    if (body) body.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function build() {
    var secs = document.querySelectorAll('.odx-pdp-sec');
    var n = 0;
    Array.prototype.forEach.call(secs, function (sec) {
      if (sec.classList.contains('odx-fold') || sec.hasAttribute('data-no-fold')) return;
      var wrap = sec.querySelector('.odx-pdp-wrap');
      var title = wrap && wrap.querySelector('.odx-pdp-sec__title');
      if (!title) return;
      /* header: a fresh wrap holding the title; body: everything that was in the section */
      var head = document.createElement('div');
      head.className = 'odx-pdp-wrap odx-fold__head';
      var body = document.createElement('div');
      body.className = 'odx-fold__body';
      var inner = document.createElement('div');
      inner.className = 'odx-fold__inner';
      body.appendChild(inner);
      while (sec.firstChild) inner.appendChild(sec.firstChild);
      head.appendChild(title);
      title.removeAttribute('style');
      sec.appendChild(head);
      sec.appendChild(body);

      var label = document.createElement('span');
      while (title.firstChild) label.appendChild(title.firstChild);
      title.appendChild(label);
      var ico = document.createElement('span');
      ico.className = 'odx-fold__ico';
      ico.setAttribute('aria-hidden', 'true');
      title.appendChild(ico);

      var id = 'OdxFold' + (++n);
      body.id = id;
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-controls', id);
      sec.classList.add('odx-fold');
      setOpen(sec, n === 1);

      function toggle() { setOpen(sec, !sec.classList.contains('is-open')); }
      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
    openFromHash();
  }

  function openFromHash() {
    if (!location.hash) return;
    var el;
    try { el = document.querySelector(location.hash); } catch (e) { return; }
    var sec = el && el.closest && el.closest('.odx-fold');
    if (sec) setOpen(sec, true);
  }

  /* links on the page that jump to something inside a closed section open it first */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var hash = a.getAttribute('href').split('#')[1];
    if (!hash) return;
    var el = document.getElementById(hash);
    var sec = el && el.closest('.odx-fold');
    if (sec) setOpen(sec, true);
  });
  window.addEventListener('hashchange', openFromHash);

  function boot() { addStyle(); build(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
